class ProductSizeGuide extends HTMLElement {
  constructor () {
    super()
    this.current = 0
  }

  connectedCallback () {
    this.dialog = this.querySelector('[data-product-size-guide-el="dialog"]')
    this.openDialog = this.querySelector('[data-product-size-guide-el="open"]')
    this.closeDialog = this.querySelector('[data-product-size-guide-el="close"]')
    this.toggle = this.querySelector('[data-product-size-guide-el="toggle"]')
    this.switches = this.toggle?.querySelectorAll('span')
    this.cmElements = this.querySelectorAll('[data-product-size-guide-el="cm"]')
    this.inchElements = this.querySelectorAll('[data-product-size-guide-el="inch"]')
    
    this.setupListeners()
  }

  setupListeners () {
    this.toggle?.addEventListener('click', (e) => {
      this.current ^= 1
      this.update()
    })

    this.openDialog.addEventListener('click', () => {
      this.dialog.showModal()
    })

    this.closeDialog.addEventListener('click', () => {
      this.dialog.close()
    })
  }

  hide (els) {
    els.forEach((el) => el.setAttribute('aria-hidden', true))
  }

  show (els) {
    els.forEach((el) => el.removeAttribute('aria-hidden'))
  }

  update () {
    if (this.metrics[this.current] === 'cm') {
      this.show(this.cmElements)
      this.hide(this.inchElements)
    } else {
      this.hide(this.cmElements)
      this.show(this.inchElements)
    }

    this.toggle?.classList.toggle('is-switched')

    this.switches?.forEach(el => {
      el.classList.toggle('is-active')
    })
  }

  get metrics () {
    return JSON.parse(this.dataset.metrics)
  }
}

if (!customElements.get('product-size-guide')) {
  customElements.define('product-size-guide', ProductSizeGuide)
}
